
export default [
  {
    description: 'Atividades Avaliativas',
    path: '/academico/atividades_avaliativas',
    name: 'atividades_avaliativas',
    component: () => import('@/views/academico/atividadesavaliativas/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Atividades Avaliativas',
    path: '/academico/atividades_avaliativas/cadastro/:id?',
    parent: 'atividades_avaliativas',
    name: 'cadastro_atividades_avaliativas',
    component: () => import('@/views/academico/atividadesavaliativas/cadastro.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]

